module.exports = __webpack_public_path__ + "static/media/sql_baisc.4f945671.4f945671.png";